/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * }); 
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
//@TODO remove this console log
let preloader_svg = '<svg class="preloader_svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><path d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50" fill="#4b858e" stroke="none"><animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 50 51;360 50 51"/></path><!-- [ldio] generated by https://loading.io/ --></svg>';
let local_storage_variable = 'backery_addresses';
let global_zip_rates = [];
let calendar_not_working_days = [];
let cart_token = '';

// const api_url = 'https://sugarees-bakery-app.shadow.binaryfuture.io/';
const api_url = 'https://sugarees-prod-289d7ab08505.herokuapp.com';

function set_dates_to_calendar(zip_code, items_count, calendar_parent) {
    for (let date_key in global_zip_rates[zip_code]) {
        if (global_zip_rates[zip_code][date_key].toString() == '0') {
            jQuery(calendar_parent + ' .picker__day:not(.picker__day--disabled)[aria-label="' + date_key + '"]').removeClass('picker__day picker__day--infocus').addClass('picker__day--infocus picker__day--disabled').addClass('picker__day').addClass('temp-disabled');
        } else {
            jQuery(calendar_parent + ' .picker__day:not(.picker__day--disabled)[aria-label="' + date_key + '"]').attr('data-rate-cost', "$" + global_zip_rates[zip_code][date_key].toString()).addClass('picker__day picker__day--infocus').removeClass('temp-disabled');
            jQuery(calendar_parent + ' .temp-disabled[aria-label="' + date_key + '"]').attr('data-rate-cost', "$" + global_zip_rates[zip_code][date_key].toString()).removeClass('temp-disabled').removeClass('picker__day--disabled');
        }
    }
}

function numberToPrice(number) {
    var currency = '$';
    var realPrice = (number / 100).toFixed(2);
    var price = currency + " " + realPrice;

    console.log('numberToPrice(' + number + '); result:' + price);

    return price;
}

Shopify.queue = [];

Shopify.moveAlong = function () {
    var request = Shopify.queue.shift();
    Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);


    ajaxAddSuccess();

    console.log('Shopify.moveAlong = function()');

};

Shopify.changeItem = function (variant_id, quantity, callback) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&id=' + variant_id,
        dataType: 'json',
        success: function (cart) {
            ajaxAddSuccess();
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };
    $.ajax(params);
};

Shopify.updateAlong = function () {
    var request = Shopify.queue.shift();
    Shopify.changeItem(request.variantId, request.quantity, Shopify.updateAlong);



    console.log('Shopify.updateAlong = function()');

    ajaxAddSuccess();
};

Shopify.removeAlong = function () {
    var request = Shopify.queue.shift();
    Shopify.removeItem(request.variantId, Shopify.updateAlong);

    // If we still have requests in the queue, let's process the next one.
    if (Shopify.queue.length) {
    }
    else {
    }

    console.log('Shopify.removeAlong = function()');


};

function onCalculateRate() {
    // Clear Old Values...
    $("div#outlet .picker__day:not(.picker__day--disabled)").removeAttr('data-rate-cost');
    let items_count = '';
    let zip_code = $('#zip-picker').val();
    $('#outlet').attr('data-zip-code', zip_code);

    var validDates = $.unique($('.picker__day:not(.picker__day--disabled), .picker__day.temp-disabled')).map(function() {
        return $(this).attr('aria-label');
    }).get();

    calculateShippingFees(zip_code, validDates);
}

/**
 * Interfaces with Heroku server to get shipping fees.
 * Saves relevant information to the Heroku server for quick lookup.
 */
async function calculateShippingFees(zip = null, cal_dates = null) {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        let cart_json = cart;
        console.table(cart_json);
        cart_token = cart_json['token'];
        console.log(typeof cart_json);
        delete global_zip_rates[zip];
        $.ajax({
            type: 'POST',
            crossDomain: true,
            data: JSON.stringify({ 'zip': zip, 'data': cart_json, 'cal': cal_dates}),
            contentType: 'application/json',
            url: api_url + "/webhooks/shipping-preview",
            success: function (response) {
                if (response['errors'] != null) {
                    const error_holder = $('.ajax-response')
                    const error_message = $("#ajax-error-message");
                    var errors = 0;
                    var new_error_message = error_message.clone();
                    new_error_message.attr('id', error_message.attr('id') + errors);
                    new_error_message.text("Please fix the following errors and try again.");
                    new_error_message.css('display', '');
                    new_error_message.css('text-decoration', 'underline');
                    error_holder.append(new_error_message);
                    response['errors'].forEach(function(error) {
                        errors += 1;
                        var new_error_message = error_message.clone();
                        new_error_message.attr('id', error_message.attr('id') + errors);
                        new_error_message.text(error);
                        new_error_message.css('display', '');
                        error_holder.append(new_error_message);
                    });
                }else if (response['calendar'] == true) {
                    global_zip_rates[zip] = response['prices'];
                    set_dates_to_calendar(zip, 1, 'div#outlet');
                    //$(".Cart__Checkout").prop('disabled', 'disabled');
                    $('#main-checkout').removeAttr('disabled');
                    $('#calculate-rates').show();
                    $('#calculate-rates').next().remove();
                } else {
                    //$(".Cart__Checkout").prop('disabled', 'disabled');
                    $('#main-checkout').removeAttr('disabled');
                    $('#calculate-rates').show();
                    $('#calculate-rates').next().remove();
                    $('#processing-message').hide();
                }

            },
            error: function(xhr, status, error) {
                // Request that user reloads page?
                // Force page reload?
                // Throw error?
                // Do something.
                console.log(error);
                console.error('Error in AJAX call:', error);
                $('.ajax-response').css('display', '');
                $("#ajax-error-message").text(error);
                //$(".Cart__Checkout").prop('disabled', 'disabled');
                $('#main-checkout').removeAttr('disabled');
                $('#calculate-rates').show();
                $('#calculate-rates').next().remove();
            } 
        });
    })
    .catch(error => console.error('Error fetching cart:', error));
}

function updateCartTotal() {
    setTimeout(function () {
        jQuery.getJSON('/cart.js', function (cart) {
            for (var i = 0; i < cart.items.length; i++) {
                var item = cart.items[i];
                var elem = $('.product-' + item.id + ' .money');
                elem.html(Shopify.formatMoney(item.price * item.quantity));
                $('.cart__subtotal').html(Shopify.formatMoney(cart.total_price));
            };
        });

    }, 300);

    console.log('updateCartTotal()');

};

function updateCartnumber(cart) {
    if (cart) {
        $('.CartCount').text('(' + cart.item_count + ')');
    }
    else {

        setTimeout(function () {

            jQuery.getJSON('/cart.js', function (cart) {
            })
                .done(function (cart) {


                    console.log('updateCartnumber(); qty: ' + cart.item_count + '; #CartCount length: ' + $('#CartCount').length);


                    $('.CartCount').text('(' + cart.item_count + ')');
                })
        }, 300);
    }
}

Shopify.addItem = function (id, qty, properties) {
    var params = {
        quantity: qty,
        id: id
    };
    if (properties != false) {
        params.properties = properties;
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: params,
        async: false,
        success: function () {
            ajaxAddSuccess();
            Shopify.moveAlong();
        },
        error: function () {
            consolo.log('Error adding to cart');
        }
    });
    console.log('Shopify.addItem = function(id, qty, properties)');
    if (window.location.href.indexOf('sample') <= 0 && $(window).width() > 768) {
        if (qty > 0) {
            $('.cartdrawer').addClass('toggle-cart');
            $('.site-header').addClass('not-transparent');
        }
    }
}

function removeItem(id) {
    push_to_queue(id, 0);
    Shopify.updateAlong();

    console.log('removeItem(id); id:' + id);

}

function push_to_queue(variantID, quantity, properties) {
    Shopify.queue.push({
        variantId: variantID,
        quantity: quantity,
        properties: properties
    });
    console.log('push_to_queue(variantID, quantity, properties), values:' + variantID + ', ' + quantity + ', ' + properties);

}

function clearCart() {
    Shopify.clear(function () {
        console.log('Cart cleared');
    });

    console.log('clearCart()');

}

function callback() {
    //window.location.href = "/cart";
    console.log('callback()');
}

function ajaxAddSuccess() {

    $('.item-total-price:not(.upsell-item-total-price), .subtotals').addClass('ajax-loading');

    setTimeout(function () {

        jQuery.getJSON('/cart.js', function (cart) {
        })
            .done(function (cart) {

                console.log('ajax download done');
                updateCartnumber(cart);
                $('.subtotals').text(numberToPrice(cart.total_price));
                $('.subtotals').removeClass('ajax-loading');
                var i;

                for (i = 0; i < cart.items.length; i++) {
                    var itemLine = i + 1;

                    $('.CartItem[data-line="' + itemLine + '"] .CartItem__PriceTotal').text(numberToPrice(cart.items[i].line_price));
                    $('.CartItem[data-line="' + itemLine + '"] .CartItem__PriceTotal').removeClass('ajax-loading');
                    console.log('itemId: ' + itemLine);
                }
            })
    }, 600);
}
function render(props) {
    return function (tok, i) { return (i % 2) ? props[tok] : tok; };
}


function updateCart(elem, remove) {
    console.log('updateCart()');

    if (remove == 'remove') {

        var id = $(elem).parents('.CartItem').data('id');

        push_to_queue(id, 0);

        Shopify.updateAlong();

        $(elem).parents('.CartItem').slideUp(transition);

        noProducts(id);
    }
    else {

        var id = $(elem).parents('.CartItem').data('id');

        console.log('ajax-id: ' + id);

        setTimeout(function () {

            var qty = elem.parents('.input__number-holder').find('input').val();

            push_to_queue(id, qty);

            if (qty == 0) {

                $(elem).parents('.item-holder').slideUp(transition);

                noProducts(id);
            }

            Shopify.updateAlong();

        }, 300);


    }
}

function noProducts(id) {
    if ($('.item-holder:not([data-id="' + id + '"]):visible').length < 1) {
        $('#noProducts').slideDown(transition);
    }
}

function updateCartTotal(cart) {
    if (cart) {
        $('.Cart__Total .subtotals').text(numberToPrice(cart.items_subtotal_price));
    }
    else {
        setTimeout(function () {
            jQuery.getJSON('/cart.js', function (cart) {
                $('.Cart__Total .subtotals').text(numberToPrice(cart.items_subtotal_price));
            })
        }, 300)
    }
}

const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

function validateCheckoutForm() {
    var type = $('#cartCheckoutForm').data('type');
    valid = 1;
    console.log('the type is: ' + type);
    if (type == 'SchedulePickup') {
        console.log('form type: SchedulePickup');

      if($('#StorePickUpTime').val().length == 0 && $('.Zapiet-Select__Option--selected').length == 1) {
       $('#StorePickUpTime').val($('.Zapiet-Select__Option--selected').html());
      }

      if($('#StorePickUpDate').val().length == 0 && $('#Zapiet-InputCalendar__pickup').length > 0){
        $('#StorePickUpDate').val($('#Zapiet-InputCalendar__pickup').val());
      }
      
        if ($('#StorePickUpDate').val().length > 0 && $('#StorePickUpTime').val().length > 0) {
            console.log('SchedulePickup datetime valid');
            $('.datetime').removeClass('error');
        }
        else {
            console.log('SchedulePickup datetime not valid: ' + $('#StorePickUpDate').val().length + '; ' + $('#StorePickUpTime').val().length);
            valid = 0;
            $('.datetime, [name="datetime"]').addClass('error');
        }
        if ($('#number').val().length > 0) {

            $('#phone').removeClass('error');
        }
        else {
            valid = 0;
            $('#phone').addClass('error');
        }
    }
    else if (type == 'PickupToday') {
        console.log('axxaxax')
        if ($('#StorePickUpDate').val().length > 0) {
            console.log('#StorePickUpDate valid. val: ' + $('#StorePickUpDate').val());
            $('.pickup-delivery-wrapper .todayDate').removeClass('error');
        }
        else {
            console.log('#StorePickUpDate not valid. val: ' + $('#StorePickUpDate').val());
            valid = 0;
            $('.pickup-delivery-wrapper .todayDate').addClass('error');
        }
        if ($('#number').val().length > 0) {

            $('#phone').removeClass('error');
        }
        else {
            valid = 0;
            $('#phone').addClass('error');
        }
    }
    else {
        valid = sug_global_selected_date != null;
        if (!valid) {
            $('#zip-input-error').show();
        }
        else {
            $('#zip-input-error').hide();
        }
    }
    return valid;
}

function genDatePicker() {

    console.log('genDatePicker; ' + 'calendar_not_working_days.length: ' + calendar_not_working_days.length);
    // check is we alredy have not working days
    if (calendar_not_working_days.length) {
        getDatePickerFunc();
    }
    // go to our server to get them and than init calendar
    else {
        $.ajax({
            type: 'GET',
            dataType: "json",
            crossDomain: true,
            url: api_url + "/get_holidays.php?l=372",
            success: function (responseData, textStatus, jqXHR) {
                // calendar_not_working_days = responseData;
                for (let i = 0; i < responseData.length; i++) {
                    calendar_not_working_days.push(new Date(responseData[i]));
                }

                getDatePickerFunc();
            },
            error: function (responseData, textStatus, errorThrown) { }
        });
    }
}

function getDatePickerFunc() {
    console.log('getDatePickerFunc');

    if ($('[data-type="SchedulePickup"]').length > 0) {
        console.log('pickupxxxxx')
        // $('.wor_title.wsaio-alerts,.wsaio-alerts').remove()
        // $('[name="checkout"]').removeClass('checkout-disabled')
        // $('[name="checkout"]').removeAttr('disabled')
        // $('[name="checkout"]').attr('style','pointer-events: auto !Important;')

    } else {
        console.log('shipipxxxxxxx')
    }


    var type = $('#cartCheckoutForm').data('type');

    var todayDelivery = 1;
    if ($('.datetime').data('today') != undefined) {
        todayDelivery = $('.datetime').data('today');
    }
    var today = new Date(); //new Date((new Date()).valueOf() - todayDelivery*1000*60*60*24);
    // var other_date = new Date('22 Nov 2022 00:00:00 GMT');
    console.log('!!!!!!!!!!!!!');
    console.log(today);
    // console.log(other_date);

    if ($('.datetime').data('disable-days') != undefined) {
        noDelivery = $('.datetime').data('disable-days');
    }

    if ($('.datetime').data('open') != undefined) {
        var openTime = $('.datetime').data('open');
        var opens = $('.datetime').data('opens');
        var closes = $('.datetime').data('closes');
    }

    if (type == 'SchedulePickup') {
        var timepicker = $('#time').pickatime({
            container: '#outlet',
            onSet: function (item) {

                if ('select' in item) setTimeout(function () {
                    $datetime.
                        off('focus').
                        val(datepicker.get() + ', ' + timepicker.get()).
                        focus().
                        on('mouseup', function () {
                            datepicker.open();
                            console.log('opening 2');
                        })
                }, 0)
                if (type == 'SchedulePickup') {
                    if (datepicker.get() != '') {
                        console.log('StorePickUpDate adding val: ' + datepicker.get());
                        $('#StorePickUpDate').val(datepicker.get());
                    }
                    $('#StorePickUpTime').val(timepicker.get());

                  console.log('date: ', datepicker.get(), '; time: ', timepicker.get());
                }
                else {
                    $('#ShippingDate').val(datepicker.get());
                }
            },
            disable: openTime,
            today: '',
            clear: '',
            close: '',
            onOpen: function () {
                $('.date--picker').removeClass('picker--opened');
            },
            onClose: function () {
                $('.date--picker').addClass('picker--opened');
            }
        }).pickatime('picker');
    }

    var datepicker = $('#date').pickadate({
        container: '#outlet',
        onRender: function (test) {
          console.log(test);
          if (type != 'SchedulePickup') {
            //onCalculateRate();
          }
        },
        onSet: function (item) {
            if (type == 'SchedulePickup') {
                if ('select' in item) setTimeout(timepicker.open, 0)
                console.log('')

                var curr_date = new Date();
                var curr_hour = curr_date.getHours();
                var curr_min = curr_date.getMinutes();
                curr_min = (Math.round(curr_min / 15) * 15) % 60;
                var selectedDate = new Date(item.select);
                if (curr_date.getDate() == selectedDate.getDate()) {
                    console.log('same date; opens: ' + opens + '; closes: ' + closes);
                    timepicker.set('enable', true);
                    timepicker.set('disable', [{ from: [0, 0], to: [curr_hour, curr_min] }, { from: closes, to: [23, 30] }])
                }
                else {
                    console.log('diff date; opens: ' + opens + '; closes: ' + closes);
                    timepicker.set('enable', true);
                    //timepicker.set('enable',  [{from: opens,to: closes}])
                    timepicker.set('disable', [{ from: [0, 0], to: opens }, { from: closes, to: [23, 30] }])
                }
            }
            else {
                let parent = $('#outlet');
                let zip_code = parent.attr('data-zip-code');
                let items_count = 0;
                $('.Cart--expanded .CartItem__Info>.CartItem__Actions .QuantitySelector__CurrentQuantity').each(function () {
                    items_count += parseInt($(this).val());
                });

                // update prices in calendar
                set_dates_to_calendar(zip_code, items_count, '#outlet[data-zip-code="' + zip_code + '"]');
                if (datepicker.get() != '') {

                    $('#ShippingDate').val(datepicker.get());
                    $datetime.val(datepicker.get());
                    console.log('new value added: ' + datepicker.get());
                    if ($('[data-pick="' + item.select + '"]').attr('data-rate-cost') !== undefined) {
                        //$(".Cart__Checkout").prop('disabled', false);
                    }                    
                    clearMultiship();
                }
            }
        },
        onOpen: function () {
            let parent = $('#outlet');
            let zip_code = parent.attr('data-zip-code');
            let items_count = 0;
            $('.Cart--expanded .CartItem__Info>.CartItem__Actions .QuantitySelector__CurrentQuantity').each(function () {
                items_count += parseInt($(this).val());
            });

            // update prices in calendar
            set_dates_to_calendar(zip_code, items_count, '#outlet[data-zip-code="' + zip_code + '"]');
            $('html').css("--calendar-height", ($('.picker__frame').outerHeight()) + 'px');
        },
        disable: [
            { from: [0, 0, 0], to: today }
        ],
        today: '',
        clear: '',
        close: '',
        format: 'mmmm d, yyyy'
    }).pickadate('picker');
    /* should add above to open automatically
    ,
          klass: {
              picker: "picker date--picker picker--opened",
              opened: "__always-open__"
          }
  
          */
    datepicker.set('disable', [1, 2]);
    datepicker.set('disable', calendar_not_working_days);

    var $datetime = $('#datetime').
        on('mouseup', function (event) {
            event.stopPropagation(); datepicker.open();
            console.log('opening')
        });

    // datepicker.set('disable', noDelivery);
}

function genItemDateFunc() {
    var todayDelivery = 1;
    if ($('.datetime').data('today') != undefined) {
        todayDelivery = $('.datetime').data('today');
    }
    var today = new Date();//new Date((new Date()).valueOf() - todayDelivery*1000*60*60*24);


    if ($('.datetime').data('disable-days') != undefined) {
        noDelivery = $('.datetime').data('disable-days');
    }

    if ($('.datetime').data('open') != undefined) {
        var openTime = $('.datetime').data('open');
        var opens = $('.datetime').data('opens');
        var closes = $('.datetime').data('closes');
    }

    $('.itemDate').each(function () {
        var elem = $(this);
        var datepicker = $(this).pickadate({
            onOpen: function (item) {
                let parent = this.$root.parents('.itemMultishipAddress');
                let zip_code = parent.attr('data-zip-code');
                let items_count = parent.find('.quantityInput').val();

                // update prices in calendar
                set_dates_to_calendar(zip_code, items_count, '.itemMultishipAddress[data-zip-code="' + zip_code + '"]');
            },
            onSet: function (item) {
                let parent = this.$root.parents('.itemMultishipAddress');
                let zip_code = parent.attr('data-zip-code');
                let items_count = parent.find('.quantityInput').val();

                // update prices in calendar
                set_dates_to_calendar(zip_code, items_count, '.itemMultishipAddress[data-zip-code="' + zip_code + '"]');

                if (datepicker.get() != '') {
                    elem.val(datepicker.get());
                    console.log('new value added: ' + datepicker.get());
                }
            },
            disable: [
                { from: [0, 0, 0], to: today }
            ],
            today: '',
            clear: '',
            close: '',
            format: 'mmmm d, yyyy'
        }).pickadate('picker');
        datepicker.set('disable', [1, 2]);
        datepicker.set('disable', calendar_not_working_days);

        // let parent = elem.parents('.itemMultishipAddress');
        // let zip_code = parent.attr('data-zip-code');
        // let items_count = parent.find('.quantityInput').val();
        // // update prices in calendar
        // set_dates_to_calendar(zip_code, items_count, '.itemMultishipAddress[data-zip-code="'+zip_code+'"]');
    });
}

function genItemDate() {
    // check is we alredy have not working days
    if (calendar_not_working_days.length) {
        genItemDateFunc();
    }
    // go to our server to get them and than init calendar
    else {
        $.ajax({
            type: 'GET',
            dataType: "json",
            crossDomain: true,
            url: api_url + "/get_holidays.php?l=595",
            success: function (responseData, textStatus, jqXHR) {
                // calendar_not_working_days = responseData;
                for (let i = 0; i < responseData.length; i++) {
                    calendar_not_working_days.push(new Date(responseData[i]));
                }

                genItemDateFunc();
            },
            error: function (responseData, textStatus, errorThrown) { }
        });
    }
}

function addTodayDate() {
    var d = new Date();

    var month = d.getMonth() + 1;
    var day = d.getDate();

    var output = (day < 10 ? '0' : '') + day + ' ' + monthNames[d.getMonth()] + ', ' + d.getFullYear();

    $('.todayDate').val(output);
    $('.todayDate').trigger('input');
};

async function setCartAttributes(attributes = {}) {
    const result = await fetch("/cart/update.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            attributes: attributes
        })
    });

    return result.json();
}

async function changeItem(data) {
    const result = await fetch("/cart/change.json", {
        method: "POST",
        body: data
    });

    return result.json();
}

async function addItem(data) {
    const result = await fetch("/cart/add.json", {
        method: "POST",
        body: data
    });

    return result.json();
}

async function addById(variantId, quantity, properties) {
    const data = new FormData();
    data.append("id", variantId);
    $.each(properties, function (key, value) {
        data.append("properties[" + key + "]", value);
    });
    data.append("quantity", quantity);

    return addItem(data);
}
function appendFileToLineById(variantId, quantity, properties) {
    const data = new FormData();
    data.append("id", variantId);
    $.each(properties, function (key, value) {
        data.append("properties[" + key + "]", value);
    });
    data.append("quantity", quantity);

    return changeItem(data);
}

function appendFileToLineByIndex(oneBasedLineIndex, quantity, properties) {
    const data = new FormData();
    data.append("line", oneBasedLineIndex);

    $.each(properties, function (key, value) {
        data.append("properties[" + key + "]", value);
    });


    data.append("quantity", quantity);

    return changeItem(data);
}

$('input[type="number"]:not(.custCheck)').on('input', function () {

    var clearedValue = $(this).val().replace(/^0+/, '');

    if ($(this).val() !== clearedValue) {
        $(this).val(clearedValue);
    }

    if ($(this).val() > Number($(this).attr('max'))) {
        $(this).val($(this).attr('max'));
    }
    else if ($(this).val() < Number($(this).attr('min'))) {
        $(this).val($(this).attr('min'));
    }

    console.log("$('input[type='number']').bind('input', function(){}");
})

var addresses = [];
function appendAddresses() {
    // console.log(addresses);
    if (addresses.length > 0) {
        console.log('we have addresses');
        var appendHtml = '';
        for (var i = 0; i < addresses.length; i++) {

            appendHtml += '<div class="option" data-name="' + addresses[i] + '">' +
                '<input data-name="' + addresses[i] + '" type="radio" name="(custId)" value="' + addresses[i] + '" id="(custId)' + addresses[i] + '">' +
                '<label for="(custId)' + addresses[i] + '">' + addresses[i] + '</label>' +
                '</div>';
        }

        if ($('.address-holder .option:not(.addAddress):not(.default-option)').length > 0) {
            $('.address-holder .option:not(.addAddress):not(.default-option)').remove();
        }
        //$(appendHtml).insertAfter('.address-holder .addAddress');

        $('.address-holder').each(function () {
            var id = $(this).parents('.CartItem').data('id') + '-' + $(this).parents('.itemMultishipAddress').data('index');
            var custappendHtml = appendHtml.replace(/(custId)/g, id);
            $(custappendHtml).insertAfter($(this).find('.addAddress'));
            var currName = $(this).find('.default-label .option-name').html();
            var instertAfterStr;
            $(this).find('input[value="' + currName + '"]').prop("checked", true);

            console.log('curr address value: ' + $(this).find('input[value="' + currName + '"]').val());
        })

        console.log('All addresses are added');
    }
    else {
        console.log('we dont have addresses');
    }

    //console.log(addresses);
}

function updateTotalQty(parent) {

    var totalQty = 0;

    parent.find('.quantityInput').each(function () {
        totalQty = totalQty + Number($(this).val());


        parent.find('.QuantitySelector__CurrentQuantity').val(totalQty);

    })
    console.log('totalQty: ' + totalQty);
    parent.find('.QuantitySelector__CurrentQuantity:visible').trigger('input');
    updateAddressProps(parent);
}

function updateAddressProps(parent) {
    var variantIndex = parent.attr('data-line');
    var quantity = parent.find('.QuantitySelector__CurrentQuantity').val();
    var properties = {};

    var valid = 1;

    parent.find('.itemMultishipAddress').each(function () {
        var index = $(this).attr('data-index');
        let address_str = '';
        let items_count = $(this).find('.quantityInput').val();
        if ($(this).find('.options-holder input:checked').length > 0) {
            address_str = $(this).find('.options-holder input:checked').val();
        }
        else {
            address_str = $(this).find('.default-option').attr('data-label');
        }

        if (address_str != 'Select address') {
            let address_obj = address_str.split(';');
            let zip_code = address_obj[7].replace(/\s/g, "");
            $(this).attr('data-zip-code', zip_code);

            // update prices in calendar
            if (global_zip_rates[zip_code]) {
                setTimeout(function () {
                    set_dates_to_calendar(zip_code, items_count, '.itemMultishipAddress[data-zip-code="' + zip_code + '"]');
                }, 2000);
            }
            else {
                $.ajax({
                    type: 'GET',
                    dataType: "json",
                    crossDomain: true,
                    url: api_url + "/get_rates.php?l=796&zip=" + zip_code,
                    success: function (responseData, textStatus, jqXHR) {
                        if (responseData['type']) {
                            global_zip_rates[zip_code] = responseData['data'];
                            set_dates_to_calendar(zip_code, items_count, '.itemMultishipAddress[data-zip-code="' + zip_code + '"]');
                            console.log(global_zip_rates);
                        }
                    },
                    error: function (responseData, textStatus, errorThrown) {
                    }
                });
            }
        }

        properties['Address ' + index] = address_str;
        properties['Address ' + index + ' quantity'] = items_count;
        properties['Address ' + index + ' delivery date'] = $(this).find('.itemDate').val();
        properties['_Cart_Token'] = cart_token;

        if ($(this).find('.Form__Textarea').val().length > 0) {
            properties['Address ' + index + ' gift message'] = $(this).find('.Form__Textarea').val();
        }
    });

    // console.log('!!!!!!!!!!!!SETUPED NEW ADDRESSS!!!!!!!!!!!!');
    // console.log(properties);

    appendFileToLineByIndex(variantIndex, quantity, properties);

}

function clearMultiship() {

    $('.CartItem').each(function () {
        var variantIndex = $(this).attr('data-line');
        var quantity = $(this).find('.QuantitySelector__CurrentQuantity').val();
        var properties = {};
        properties['_Multiship'] = 'Off';
        properties['Arrival Date'] = sug_global_selected_date;
        properties['_Cart_Token'] = cart_token;
        appendFileToLineByIndex(variantIndex, quantity, properties);
        console.log('clearing the address for line: ' + variantIndex);
    })
}

function validateMultishipCart() {
    var valid = 1;

    $('.itemMultishipAddress').each(function () {
        if ($(this).find('.options-holder input:checked').length == 0) {
            valid = 0;
            $(this).find('.vertical-select-field').addClass('error');
        }
        else {
            $(this).find('.vertical-select-field').removeClass('error');
        }

        if ($(this).find('.itemDate').val().length == 0) {
            $(this).find('.itemDate').addClass('error');
            valid = 0;
        }
        else {
            $(this).find('.itemDate').removeClass('error');
        }
    })

    return valid;
}

function adjustAirbnbIframe() {
    console.log('$(window).width() ' + $(window).width());
    console.log('airbnb-embed-frame outerWidth(): ' + $('.airbnb-embed-frame').outerWidth());
    let scale = $('.airbnb-embed-frame').parents('.html-holder').outerWidth() / $('.airbnb-embed-frame').outerWidth();
    $('.airbnb-embed-frame').css('transform', 'scale(' + scale + ')').css('margin', '-' + (100 - scale * 100) + '% 0');
}

function adjustProdWeekDay(elem) {
    /*
      var weekDay = new Date().getDay();
    var days = elem.data('days');

    if(days.indexOf(weekDay) > -1){
      elem.removeClass('weekday');
    }
    else{
      if(elem.parent('.Grid__Cell').length > 0){
        elem.parent('.Grid__Cell').remove();
      console.log('element parent removed');
      }
      else{
      elem.remove();
      console.log('element removed');
      }
    }
    */
}

async function adjustWeekDays() {
    var weekDay = new Date().getDay();

    $('[data-section-type="announcement-with-image"][data-visibility="true"], [data-section-type="announcement-section"][data-visibility="true"]').each(function () {
        console.log('weekDay is ' + weekDay);
        if ($(this).data('visible-days').indexOf(weekDay) > -1) {
            $(this).show();
        }
    })

    $('.ProductItem.weekday:not(.adjusted)').each(function () {
        adjustProdWeekDay($(this));
    })

    if ($('.ProductListWrapper .Grid[data-max]').length > 0) {
        $('.ProductListWrapper .Grid[data-max]').each(function () {
            var parent = $(this);
            console.log('new ProductListWrapper found: length: ' + parent.find('.ProductItem').length + '; max: ' + parent.data('max') + '; vis:' + parent.find('.ProductItem:visible').length);
            if (parent.find('.ProductItem:visible').length < parent.data('max') && parent.find('.ProductItem').length > parent.data('max')) {
                parent.find('.ProductItem:hidden').each(function () {
                    console.log('new item found: length: ' + parent.find('.ProductItem').length + '; max: ' + parent.data('max') + '; vis:' + parent.find('.ProductItem:visible').length);

                    if (parent.find('.ProductItem:visible').length < parent.data('max')) {
                        $(this).parents('.Grid__Cell').show();
                    }
                })
            }
        })
    }

    $('.CartItem.weekday').each(async function () {
        if ($(this).data('days').indexOf(weekDay) > -1) {
            console.log('cart item has the day');
        }
        else {
            console.log('cart item doesnt have the day');
            var id = $(this).data('id');
            var wait = await appendFileToLineById(id, 0, '');
            console.log('item is removed');
            $(this).remove();
        }
    })

    $('.DayRelated').each(function () {
        console.log('weekDay is ' + weekDay);
        if ($(this).data('visible-days').indexOf(weekDay) > -1) {
            $(this).show();
        }
    })
}

function hideTodayPickup() {
    var disableDays = $('html').data('disable-pickup-days');
    const d = new Date();
    let day = d.getDay() + 1;

    var shouldHide = 0;

    for (var i = 0; i < disableDays.length; i++) {
        if (disableDays[i] == day) {
            shouldHide = 1;
        }
    }
    //console.log('disableDays has length: ' + disableDays.length + '; shouldHide: ' + shouldHide + '; day: ' + day);

    if (shouldHide == 1) {
        if ($('.options-holder .option[data-name="Pickup Today"]').length > 0) {
            $('.options-holder .option[data-name="Pickup Today"]').remove();
        }

        if ($('.ProductForm__Option select').find('option[data-option1="Pickup Today"], option[data-option2="Pickup Today"], option[data-option3="Pickup Today"]').length > 0) {
            $('.ProductForm__Option select').find('option[data-option1="Pickup Today"], option[data-option2="Pickup Today"], option[data-option3="Pickup Today"]').remove();
        }
    }
}
var sentProducts = [];
async function addMultiById() {
    var currProd = sentProducts[0];
    console.log('currProd: ', currProd);
    console.log(
        JSON.stringify({
            quantity: currProd[1],
            id: currProd[0],
            properties: currProd[2]
        }));
 
    $.post(
        '/cart/add.js',
        {
            quantity: currProd[1],
            id: currProd[0],
            properties: currProd[2]
        },

        null,
        'json'
    ).done(function () {
        console.log('Adding next product!');

        sentProducts.splice(0, 1);
        if (sentProducts.length) {
            addMultiById();
        } else {
            console.log('all products were added!');

            localStorage.setItem(local_storage_variable, JSON.stringify(addresses));
            window.location = '/cart?bulkorder=true';
        }
    });
}

async function addObjectToCart(ordersObject) {
    let cart = await setCartAttributes({ Multiship: "true", BulkOrder: "true" });

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let cart_json = cart;
            cart_token = cart_json['token'];
        })
        .then(() => {
            console.log('ordersObject: ', JSON.stringify(ordersObject));

            console.log('Bulkorder enabled');

            $.each(ordersObject, async function (index) {
                console.log('ordersObject[' + index + ']: ', JSON.stringify(ordersObject[index]));

                var totalQuantity = 0;

                properties = {};

                var productLine = ordersObject[index];

                var variantId = productLine[0][0];
                console.log('productLine: ', productLine);

                for (let i = 0; i < productLine.length; i++) {
                    let address = productLine[i];
                    console.log('address: ', address)
                    totalQuantity = totalQuantity + Number(address[1]);

                    let index = i + 1;

                    properties['Address ' + index] = address[4];
                    //properties['Addres '+index+' product name'] = address[1];
                    properties['Address ' + index + ' user input name'] = 'test';
                    properties['Address ' + index + ' quantity'] = address[1];
                    properties['Address ' + index + ' delivery date'] = address[2];
                    properties['Address ' + index + ' zip'] = address[5];
                    properties['_Cart_Token'] = cart_token;

                    if (address[3] != '') {
                        properties['Address ' + index + ' gift message'] = address[3];
                    }

                    properties['__Address ' + index + ' dashboard_details'] = address[7];

                    

                }
                console.log('Line Item: ', JSON.stringify(properties));
                sentProducts.push([variantId, totalQuantity, properties]);

                //console.log('item added: ', sentProducts);
            })
            console.log('sentProducts: ', JSON.stringify(sentProducts));
            addMultiById();
    });
}

async function corporateManageResults(results) {
    console.log('corporateAddToCart with results length: ' + results.data.length);
    var sortResults = results.data.sort();
    Object.keys(sortResults).forEach((key) => (!$.isNumeric(sortResults[key][0])) && delete sortResults[key]);
    let actualResults = Object.fromEntries(Object.entries(sortResults).filter(([_, v]) => v != null));

    console.log(actualResults);
    var firstValue;
    var ordersObject = {};
    $.each(actualResults, function (i) {

        var line = actualResults[i];
        debugger;

        // Object from Order Information.
        let order_information = {
            bulk_id: line[0],
            item_name: line[1],
            item_quantity: line[2],
            first_name: line[3],
            last_name: line[4],
            business: line[5],
            phone: line[6],
            address_1: line[7],
            address_2: line[8],
            city: line[9],
            zip: line[10],
            note: line[11],
            shipping_date: line[12]
        };

        // Encode the Order Information.
        let order_string = JSON.stringify(order_information);

        // This code naively assumes that there will be no commas in any string.
        // Iterate through each string in the array and remove commas
        line.forEach((str, index, array) => {
            array[index] = str.replace(/,/g, '');
        });

        console.log("LINE HERE: ", line);
        var variantId = productIds[line[0]];
        if ($.isNumeric(variantId)) {
            var quantity = line[2];
            var date = line[12];
            var giftMessage = line[11];
            var company = line[5];
            var zip = line[10];

            if (company == '') {
                company = '-';
            }
            var formDetails = line[2] + ' ' + line[3] + ', ' + company + ', ' + line[4] + ', ' + line[5] + ', ' + line[6] + ', ' + line[7] + ', ' + line[8] + ', ' + line[9] + ', United States';
            //console.log('prodNum: '+ line[0] +'; variantId: ' + variantId + '; quantity: '+ quantity +'; date: ' + date + '; address:' + formDetails + '; giftMessage: ' + giftMessage);
            formDetails = formDetails.replace(/\, ,/g, ', ');
            var formDetailsArr = [formDetails];
            addresses.push(formDetailsArr);


            console.log([variantId, quantity, date, giftMessage, formDetails]);
            if (line[0] != firstValue) {
                firstValue = line[0];
                ordersObject[firstValue] = [];
                ordersObject[firstValue].push([variantId, quantity, date, giftMessage, formDetails, zip, line[1], order_string]);
            }
            else {
                ordersObject[firstValue].push([variantId, quantity, date, giftMessage, formDetails, zip, line[1], order_string]);
            }
            //console.log('firstValue: ' + firstValue);
        }
    })
    addObjectToCart(ordersObject);
}

async function corporateFileUpload() {
    var inputType = "string";
    var stepped = 0, rowCount = 0, errorCount = 0, firstError;
    var start, end;
    var firstRun = true;
    var maxUnparseLength = 10000;

    function errorFn(err, file) {
        end = now();
        console.log("ERROR:", err, file);
        enableButton();
    }

    function completeFn(results) {
        end = now();

        if (results && results.errors) {
            if (results.errors) {
                errorCount = results.errors.length;
                firstError = results.errors[0];
            }
            if (results.data && results.data.length > 0)
                rowCount = results.data.length;
        }

        printStats("Parse complete");
        console.log("    Results:", results);
        console.log("Moving to corporateAddToCart");
        corporateManageResults(results);
    }

    function now() {
        return typeof window.performance !== 'undefined'
            ? window.performance.now()
            : 0;
    }
    function printStats(msg) {
        if (msg)
            console.log(msg);
        console.log("       Time:", (end - start || "(Unknown; your browser does not support the Performance API)"), "ms");
        console.log("  Row count:", rowCount);
        if (stepped)
            console.log("    Stepped:", stepped);
        console.log("     Errors:", errorCount);
        if (errorCount)
            console.log("First error:", firstError);
    }

    function buildConfig() {
        return {
            complete: completeFn,
            error: errorFn,
            download: inputType == "remote"
        };
    }

    var config = buildConfig();
    var input = $('.fileSelect').val();
    $('.submitFile').click(function (e) {
        e.preventDefault();
        $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            success: function () {
            },
            dataType: 'json'
        }).then(() => {
            if (!$('.fileSelect')[0].files.length) {
                alert("Please choose at least one file to parse.");
                return false;
            }
            else {
                var currentFile = $('.fileSelect')[0].files[0];

                if (currentFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || currentFile.name.toLowerCase().endsWith('.xlsx')) {
                    $('body').addClass('loading-bar');
                    console.log("Converting file to CSV...")
                    // Loading the XLSX file...
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        var data = e.target.result;
                        var workbook = XLSX.read(data, { type: 'binary' });

                        // Get proper sheet
                        var csvData = XLSX.utils.sheet_to_csv(workbook.Sheets["Order Form"]);
                        var papadata = Papa.parse(csvData);

                        // Send to completeFn
                        completeFn(papadata);



                        end = now();
                        printStats("Done with all files");
                    };

                    // Read file
                    reader.readAsBinaryString(currentFile);
                }
                else if (currentFile.type === 'text/csv' || currentFile.name.toLowerCase().endsWith('.csv')) {
                    $('body').addClass('loading-bar');
                    $('.fileSelect').parse({
                        config: config,
                        before: function (file, inputElem) {
                            start = now();
                            console.log("Parsing file...", file);
                        },
                        error: function (err, file) {
                            console.log("ERROR:", err, file);
                            firstError = firstError || err;
                            errorCount++;
                        },
                        complete: function () {
                            end = now();
                            printStats("Done with all files");
                        }
                    });
                }
                else {
                    alert("Please select XLSX or CSV file format.");
                    return false;
                }
            }
        })
    })
}

function updateQuickFormShippingOption() {
    var parent = $('[data-section-type="quick-order-form"]');
    var fieldName = parent.find('.vertical-select-field').data('name');

    if ($('input[name="' + fieldName + '"]:checked').length > 0) {
        var currentValue = $('input[name="' + fieldName + '"]:checked').val();
    }
    else {
        var currentValue = parent.find('input[name="' + fieldName + '"]').first().val();
    }

    $('.variant').removeClass('active');
    $('.variant[data-last-option="' + currentValue + '"]').addClass('active');

    $('.variants-holder').each(function () {

        if ($(this).find('.variant.active').length == 0) {

            $(this).parents('.product-holder').find('.price-holder').html($(this).find('.variant').first().data('price'));
            $(this).find('.no-options-holder').show();

            $(this).parents('.product-holder').find('.product-quantity-holder .ProductForm__QuantitySelector').slideUp(300);
            $(this).parents('.product-holder').find('.product-quantity-holder .product-unavailable').slideDown(300);

        }
        else {
            $(this).parents('.product-holder').find('.price-holder').html($(this).find('.variant.active').first().data('price'));
            $(this).find('.no-options-holder').hide();

            $(this).parents('.product-holder').find('.product-quantity-holder .product-unavailable').slideUp(300);
            $(this).parents('.product-holder').find('.product-quantity-holder .ProductForm__QuantitySelector').slideDown(300);
        }

        if ($(this).parents('.product-holder').find('.product-quantity-holder .ProductForm__QuantitySelector').length > 0) {
            if ($(this).find('.variant.active').length == 0) {
                var qtyVariant = $(this).find('.variant').first();
            }
            else {
                var qtyVariant = $(this).find('.variant.active').first();
            }
            if (qtyVariant.data('quantity') != 'unset') {
                $(this).parents('.product-holder').find('.product-quantity-holder .maxQty').html(qtyVariant.data('quantity'));
                $(this).parents('.product-holder').find('.product-quantity-holder .QuantitySelector__CurrentQuantity').attr('max', qtyVariant.data('quantity'));
                $(this).parents('.product-holder').find('.product-quantity-holder .maxQtyHolder').show();
            }
            else {
                $(this).parents('.product-holder').find('.product-quantity-holder .maxQtyHolder').hide();
                $(this).parents('.product-holder').find('.product-quantity-holder .QuantitySelector__CurrentQuantity').attr('max', '');
            }
        }
    })
}

function updateSiblingsQty(elem) {
    console.log('triggered');
    if (elem.parents('.variant').length > 0) {
        var variantElem = elem.parents('.variant');
        var cleanTitle = variantElem.data('clean-title');
        variantElem.siblings('[data-clean-title="' + cleanTitle + '"]').find('.QuantitySelector__CurrentQuantity').val(elem.val());
    }
    else {
        elem.parents('.product-holder').find('.variant.active .QuantitySelector__CurrentQuantity').val(elem.val());

        console.log('hidden variant value: ' + elem.parents('.product-holder').find('.variant.active .QuantitySelector__CurrentQuantity').val());
    }
}

var quickFormProducts = [];
async function addFormProductToCart() {
    var currProd = quickFormProducts[0];
    console.log('currProd: ', currProd);
    $.post(
        '/cart/add.js',
        {
            quantity: currProd[1],
            id: currProd[0],
            properties: currProd[2]
        },

        null,
        'json'
    ).done(function () {
        console.log('Adding next product!');

        quickFormProducts.splice(0, 1);
        if (quickFormProducts.length) {
            addFormProductToCart();
        } else {
            console.log('all products were added!');

            window.location = '/cart';
        }
    });

}

async function prepareFormVariable() {

    $('body').addClass('loading-bar');

    $('.variant.active').each(function () {
        if ($(this).find('.QuantitySelector__CurrentQuantity').val() > 0) {
            var variantId = $(this).data('id');
            var qty = $(this).find('.QuantitySelector__CurrentQuantity').val();
            quickFormProducts.push([variantId, qty, '']);

        }
    })

    addFormProductToCart();

}

function quickOrderForm() {
    var parent = $('[data-section-type="quick-order-form"]');
    var fieldName = parent.find('.vertical-select-field').data('name');

    updateQuickFormShippingOption();

    $('.openVariants').click(function () {
        $(this).parents('.product-holder').find('.variants-holder').slideToggle(300);
    })

    parent.find('input[name="' + fieldName + '"]').change(function () {
        updateQuickFormShippingOption();
    })

    $('.submitForm').click(function () {
        prepareFormVariable();
    })

}

//localStorage.clear();
$(document).ready(async function () {

    // Shipping Fee Logic. 

    if ($('.multiship').is(':checked')) {
        calculateShippingFees();
    }
    // End Shipping Fee Logic.


    hideTodayPickup();
    adjustWeekDays();
    $('html').css("--newsletter-half-height", ($('[data-section-type="newsletter"] .form-wrapper').outerHeight() / 2) + 'px');
    //$('body:not(.template-index) #main').css("padding-bottom", ($('[data-section-type="newsletter"] .form-wrapper').outerHeight() / 2) + 'px');
    /*$('[data-section-type="instagram-section"]').each(function () {
        var section = $(this);
        var imgCount = section.data('images-count');
        console.log('imgCount is: ' + imgCount);
        var contFound = 0;
        section.find('.insta-feed').on("DOMSubtreeModified", function () {

            var appWrapper = $(this);
            if (contFound == 0) {

                if (appWrapper.find('.instafeed-new-layout-wrapper').length > 0) {

                    if (appWrapper.find('.instafeed-new-layout-wrapper').length < imgCount) {
                        imgCount = appWrapper.find('.instafeed-new-layout-wrapper').length;
                    }

                    var imagesArr = [];
                    for (var i = 1; i <= imgCount; i++) {
                        console.log('we found an image for a:nth-child(' + i + ') .instafeed-new-layout-wrapper img');
                        imagesArr.push(appWrapper.find('a:nth-child(' + i + ') .instafeed-new-layout-wrapper img').attr('data-src'));
                    }

                    console.log(imagesArr);
                    var imagesHTML = '';
                    for (var a = 0; a < imagesArr.length; a++) {

                        imagesHTML += '<div class="Grid__Cell 1/' + imagesArr.length + ' 1/2--phone margin-bottom-md">' +
                            '<div class="insta-img-wrapper padding-sm">' +
                            '<div class="insta-img-holder">' +
                            '<img src="' + imagesArr[a] + '"/>' +
                            '</div>' +
                            '</div>' +
                            '</div>';
                    }
                    section.find('.instaImagesHolder').append(imagesHTML);

                }
                else {
                    console.log('containers not found');
                }
            }
        })
    })*/
$('[data-section-type="instagram-section"]').each(function () {
  console.log('instafeed element found');
    var section = $(this);
    var imgCount = section.data('images-count');
    console.log('imgCount is: ' + imgCount);
    var contFound = 0;

    var instaFeed = section.find('.insta-feed');

    if (instaFeed.length) {
        // Create an observer instance
        const observer = new MutationObserver(() => {
  console.log('instafeed element changed');
            if (contFound === 0) {
                var appWrapper = instaFeed;

                if (appWrapper.find('.instafeed-new-layout-wrapper').length > 0) {
                    if (appWrapper.find('.instafeed-new-layout-wrapper img.instafeed-lazy-image').length < imgCount) {
                        imgCount = appWrapper.find('.instafeed-new-layout-wrapper img.instafeed-lazy-image').length;
                    }
  console.log('instafeed .instafeed-new-layout-wrapper found; imgCount: ', imgCount);

                    var imagesArr = [];
                    for (var i = 1; i <= imgCount; i++) {
                        console.log('we found an image for .instafeed-new-layout-item:nth-child(' + i + ')img.instafeed-lazy-image');
                        imagesArr.push(appWrapper.find('.instafeed-new-layout-item:nth-child(' + i + ') img.instafeed-lazy-image').attr('data-instafeed-src'));
                    }

                    console.log(imagesArr);

                    var imagesHTML = '';
                    for (var a = 0; a < imagesArr.length; a++) {
                        imagesHTML +=
                            '<div class="Grid__Cell 1/' + imagesArr.length + ' 1/2--phone margin-bottom-md">' +
                            '<div class="insta-img-wrapper padding-sm">' +
                            '<div class="insta-img-holder">' +
                            '<img src="' + imagesArr[a] + '"/>' +
                            '</div>' +
                            '</div>' +
                            '</div>';
                    }
                    section.find('.instaImagesHolder').append(imagesHTML);

                    contFound = 1; // Mark as processed
                } else {
                    console.log('containers not found');
                }
            }
        });

        // Start observing the target element
        observer.observe(instaFeed[0], {
            childList: true, // Monitor child nodes being added or removed
            subtree: true,  // Monitor all descendants
        });
    }
});

    if ($('.airbnb-embed-frame').length > 0) {

        var iframeAdjusted = 0;
        $(document).on('DOMSubtreeModified', '.airbnb-embed-frame', function () {

            if (iframeAdjusted == 0 && $(this).find('iframe').length > 0 && $(window).width() < 768) {
                adjustAirbnbIframe();
                iframeAdjusted = 1;
            }
        });
    }


    if (localStorage.getItem(local_storage_variable) != null) {
        //console.log('list: ' + localStorage.getItem('addresses'));
        addresses = JSON.parse(localStorage.getItem(local_storage_variable));
        appendAddresses();
    }



    $(document).on('mouseup', '.vertical-select-field:visible .current-option', function (e) {
        var this1 = e.target;
        $('.vertical-select-field').removeClass('current');
        $(this1).parents('.vertical-select-field').addClass('current');
        console.log('needed length: ' + $(this1).parents('.vertical-select-field').length);
        $('.vertical-select-field:not(.current)').find('.options-holder').slideUp(300);
        $(this1).parents('.vertical-select-field').find('.options-holder').slideToggle(300);

    })

    $(document).mouseup(function (e) {
        var container = $(".vertical-select-field");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.find('.options-holder').slideUp(300);
            container.removeClass('current');
            console.log('closing it');




            if ($(window).width() > 767) {
                setTimeout(function () {
                    $('.variant_tb.variant_tb2 .des_qt').attr('style', 'display:inline-block')
                }, 2000)
            } else {
                $('.variant_tb.variant_tb2 .des_qt').attr('style', 'display:none')
                setTimeout(function () {
                    $('.items.custom_variant  table#wsaio-volume-discount--table').attr('style', 'display:block !important')
                }, 2000)
            }

        }
    });

    $(document).on('mouseup', '.vertical-select-field .option:not(.current-option)', function () {
        var parent = $(this).parents('.vertical-select-field');
        $('.vertical-select-field .options-holder').slideUp(300);
        parent.find('.option').removeClass('active');
        $(this).addClass('active');
        parent.find('.current-option .option-name').html($(this).data('name'));
        parent.removeClass('current');
        console.log('closing it 2');
    })

    if ($('.datetime').length > 0) {
        genDatePicker();
    }

    if ($('.itemDate').length > 0 && $('.multiship:checked').length > 0) {
        genItemDate();
    }

    $(document).on('input', '.pickup-delivery-wrapper .todayDate', function () {
        $('#StorePickUpDate').val($(this).val()).attr('value', $('#StorePickUpDate').val());
        console.log('#StorePickUpDate changing the value now: ' + $('#StorePickUpDate').val());
    })

    if ($('.todayDate').length > 0) {
        addTodayDate();
    }

    if ($('.ProductForm__Option[data-type="delivery"] [type="radio"]').length > 0) {

        if ($('.ProductForm__Option[data-type="delivery"] [type="radio"]:checked').length > 0) {
            console.log('we have such');
            $('.ProductForm__Option[data-type="delivery"] [type="radio"]:checked').trigger('change');
            const e = new Event("change");
            const element = document.querySelector('.ProductForm__Option[data-type="delivery"] [type="radio"]:checked');
            element.dispatchEvent(e);
        }
        else {
            $('.ProductForm__Option[data-type="delivery"] [type="radio"]:first-child').trigger('change');
            const e = new Event("change");
            const element = document.querySelector('.ProductForm__Option[data-type="delivery"] [type="radio"]:first-child');
            element.dispatchEvent(e);
        }
    }

    $(document).on('input', '.Cart__Note', function () {
        console.log('val: ' + $(this).val());
        $('#GiftMessage').val($(this).val());
        console.log('cart note input. New val: ' + $('#GiftMessage').val());
    })

    $(document).on('input', '#phone', function () {
        console.log('val: ' + $(this).val());
        $('#number').val($(this).val());
        console.log('numberinput. New val: ' + $('#number').val());
    })

    $(document).on('DOMSubtreeModified', '.ws-registration-form--wrapper', function () {

        console.log('something changed');

        if ($(this).find('.waio--error-message').length > 0) {
            console.log('form not filled correctly');
        }
        else if ($(this).find('.waio--success-message').length > 0) {
            console.log('form submitted successfully');

            if ($(".wholesaleFormTop").length > 0) {
                $('html, body').animate({
                    scrollTop: $(".wholesaleFormTop").offset().top + 150
                }, 300);
            }
            $('#wsaio-form').slideUp(300);
            $('.custom-registration-success').slideDown(300);

        }

    })


    $('.Cart__Checkout').click(async function () {
        console.log('validating form');
        //validateCheckoutForm();
        var valid = validateCheckoutForm();
        if (valid == 1) {
            console.log('form valid');

            console.log('form data: ', $('#cartCheckoutForm').serializeArray());

            var serializeForm = $('#cartCheckoutForm').serializeArray();

            var attObj = {};
            for (var i = 0; i < serializeForm.length; i++) {
                console.log(serializeForm[i]);
                var line = serializeForm[i]
                if (line.name.indexOf('attributes[') > -1) {

                    var nameStrip = line.name.replace('attributes[', '').replace(']', '');
                    attObj[nameStrip] = line.value;
                }
            }

            console.log('attObj: ', attObj);
            await setCartAttributes(attObj);


            if (!$('.multiship').is(':checked')) {
                // Create an array to hold the promises
                let promises = [];
            
                $('.CartItem').each(function () {
                    var type = $('#cartCheckoutForm').data('type');
                    var variantIndex = $(this).attr('data-line');
                    var quantity = $(this).find('.QuantitySelector__CurrentQuantity').val();
                    var properties = {};
                    properties[type == 'SchedulePickup' ? 'Pickup Date' : 'Arrival Date'] = sug_global_selected_date;
                    properties['_Cart_Token'] = cart_token;
            
                    // Push the promise into the array
                    promises.push(appendFileToLineByIndex(variantIndex, quantity, properties));
                    console.log('clearing the address for line: ' + variantIndex);
                });
            
                // Wait for all promises to resolve before submitting the form
                Promise.all(promises).then(() => {
                    $('#cartCheckoutForm').submit();
                });
            } else {
                $('#cartCheckoutForm').submit();
            }
        }
        else {
            console.log('form invalid ');
        }


        
    })

    $('[data-section-type="cart"]').on("DOMSubtreeModified", function () {
        if ($(this).find('#StorePickUpDate').length == 1 && $('.pickup-delivery-wrapper .todayDate').length == 1) {
            if ($('#StorePickUpDate').val() != $('.pickup-delivery-wrapper .todayDate').val()) {
                $('#StorePickUpDate').val($('.pickup-delivery-wrapper .todayDate').val()).attr('value', $('#StorePickUpDate').val());
                // console.log('changing StorePickUpDate')
            }
        }
    })

    $(document).on('click', '.multiship', async function () {


        if ($(this).is(':checked')) {
            $('.QuantitySelector__CurrentQuantity').attr('readonly', true);
            $('#cartCheckoutForm, body').addClass('multishipCart');
            $('.CartItem .CartItem__Remove').attr('data-action', '');

            appendAddresses();

            genItemDate();
            let cart = await setCartAttributes({ Multiship: "true" });
            console.log(cart.attributes) // { foo: "bar" }

            var form = $(this).parents('form');

            form.attr('action', form.attr('data-multiship-action'));
        }
        else {
            $('.QuantitySelector__CurrentQuantity').removeAttr('readonly');
            $('.CartItem .CartItem__Remove').attr('data-action', 'remove-item');
            $('#cartCheckoutForm, body').removeClass('multishipCart');
            let cart = await setCartAttributes({ Multiship: "" });
            clearMultiship();
            console.log(cart.attributes) // { foo: "bar" }

            var form = $(this).parents('form');

            form.attr('action', form.attr('data-action'));
        }
    })

    $(document).on('input', '.CartItem .QuantitySelector__CurrentQuantity', function () {
        if ($('.multiship:checked').length > 0) {
            var id = $(this).parents('.CartItem').data('id');
            console.log('id: ' + id + '; qty: ' + $(this).val());
            push_to_queue(id, $(this).val());
            Shopify.updateAlong();
        }
        console.log('making a change 3: ' + $(this).val());

    });

    $(document).on('mouseup', '.addAddressOpen', function () {
        $('.vertical-select-field').removeClass('addingNewAddress');
        $(this).parents('.vertical-select-field').addClass('addingNewAddress');
    })

    var timeoutID;
    $('.template-cart #address_form_new').submit(function (e) {
        e.preventDefault();
        var serForm = $(this).serializeArray();
        window.clearTimeout(timeoutID);
        $('#address_form_new #callback-message').remove();

        $('#address_form_new button.Form__Submit').hide().after(preloader_svg);

        // validate address via fidex api
        $.ajax({
            type: 'POST',
            dataType: "json",
            crossDomain: true,
            data: {
                'street': serForm[6].value,
                'city': serForm[8].value,
                'zip': serForm[9].value
            },
            url: api_url + "/validate_address.php?l=1579",
            success: function (responseData, textStatus, jqXHR) {
                // let rates_data = JSON.parse(responseData);
                $('#address_form_new .preloader_svg').remove();
                $('#address_form_new button.Form__Submit').show();
                if (responseData[0]) {
                    var formDetails = serForm[2].value + '; ' + serForm[3].value + '; ' + serForm[4].value + '; ' + serForm[5].value + '; ' + serForm[6].value + '; ' + serForm[7].value + '; ' + serForm[8].value + '; ' + serForm[9].value + '; ' + serForm[10].value;
                    //console.log(formDetails);
                    formDetails = formDetails.replace(/\, ,/g, ', ');
                    var formDetailsArr = [formDetails];
                    addresses.push(formDetailsArr);
                    //console.log(addresses);
                    localStorage.setItem(local_storage_variable, JSON.stringify(addresses));

                    $('.vertical-select-field.addingNewAddress .option-name').html(formDetails);
                    $('.vertical-select-field').removeClass('addingNewAddress');
                    $('.Modal__Close').trigger('click');
                    //console.log('addresses: ' +  localStorage.getItem('addresses'));
                    appendAddresses();
                }
                else {
                    $('#address_form_new button.Form__Submit').after('<p id="callback-message">' + responseData[1] + '</p>');
                    timeoutID = window.setTimeout(function () {
                        $('#address_form_new #callback-message').remove();
                    }, 10000);
                }
            },
            error: function (responseData, textStatus, errorThrown) {
                $('#address_form_new .preloader_svg').remove();
                $('#address_form_new button.Form__Submit').show();
                alert(responseData);
            }
        });


    });

    $(document).on('change', '.address-holder .option:not(.current-option):not(.addAddress) [type="radio"]', function () {
        // console.log('changing the property');
        // console.log('ADDRESS CHANGED!!!!!!!!');
        var parent = $(this).parents('.CartItem');
        updateAddressProps(parent);
    });

    $(document).on('change', '.itemDate', function () {
        var parent = $(this).parents('.CartItem');
        updateAddressProps(parent);
    })

    $(document).on('click', '.CartItem__AddAdress', function (e) {
        e.preventDefault();

        console.log('addingNewAddress');

        var parent = $(this).parents('.CartItem');

        var addressNumber = parent.find('.itemMultishipAddress').length;

        var multishipHtml = parent.find('.itemMultishipAddress[data-index="1"]').prop('outerHTML');

        $(multishipHtml).insertAfter(parent.find('.itemMultishipAddress[data-index="' + addressNumber + '"]'));

        var newElem = parent.find('.itemMultishipAddress').last();

        newElem.attr('data-index', (addressNumber + 1));

        newElem.find('.itemDate').val('');

        newElem.find('.Form__Textarea').val('');
        newElem.find('.quantityInput').val('1');

        newElem.find('.option-name').html(newElem.find('.option.addAddress').data('name'));
        appendAddresses();
        console.log('updating total qty');
        updateTotalQty(parent);
        genItemDate();


        return false;
    })

    $(document).on('mouseup', '.CartItem__RemoveAdress', function () {
        console.log('removing the address');
        var parent = $(this).parents('.CartItem');

        $(this).parents('.itemMultishipAddress').remove();

        var index = 1;
        parent.find('.itemMultishipAddress').each(function () {
            console.log('found item. adding index : ' + index);
            $(this).attr('data-index', index);

            index++;
        })
        updateTotalQty(parent);
        console.log('updating total qty 2');
        appendAddresses();
    })
    $(document).on('input', '.quantityInput', function () {
        var parent = $(this).parents('.CartItem');
        updateTotalQty(parent);
    })

    $(document).on('change', '.itemMultishipAddress .Form__Textarea', function () {
        var parent = $(this).parents('.CartItem');
        updateAddressProps(parent);
    })

    $(document).on('mouseup', '.multishipCart .CartItem__Remove', async function (e) {
        var id = $(this).parents('.CartItem').data('id');
        var wait = await appendFileToLineById(id, 0, '');
        $(this).parents('.CartItem').remove();

        if ($('.CartItem').length == 0) {
            location.reload(true);
        }
    })

    $(document).on('mouseup', '.Cart.multishipCart button[data-type=submit]', function (e) {
        e.preventDefault();
        console.log('form submitted. pausing.');

        var valid = validateMultishipCart();

        if (valid == 1) {
            $(this).parents().filter("form").submit();
        }
        else {
            return false;
        }
    })

    $('body').on("DOMSubtreeModified", function () {
        $('.ProductItem.weekday:not(.adjusted)').each(function () {
            console.log('dom changed');
            adjustProdWeekDay($(this));
        })
    })

   /* $('[data-section-type="newsletter"] .form-wrapper').on("DOMSubtreeModified", function () {
        $('html').css("--newsletter-half-height", ($('[data-section-type="newsletter"] .form-wrapper').outerHeight() / 2) + 'px');
        $('body:not(.template-index) #main').css("padding-bottom", ($('[data-section-type="newsletter"] .form-wrapper').outerHeight() / 2) + 'px');

    })*/

  const newsletterHolder = document.querySelector('[data-section-type="newsletter"] .form-wrapper');

    if (newsletterHolder) {
        // Create an observer instance
        const observer = new MutationObserver(() => {
            const newsletterHeight = ($('[data-section-type="newsletter"] .form-wrapper').outerHeight() / 2) + 'px';

            // Update CSS variables and padding
            $('html').css('--newsletter-half-height', newsletterHeight);
            //$('body:not(.template-index) #main').css('padding-bottom', newsletterHeight);
        });

        // Start observing the target node
        observer.observe(newsletterHolder, {
            childList: true, // Monitor additions/removals of child elements
            subtree: true,  // Monitor changes within the subtree
            attributes: true // Monitor attribute changes if necessary
        });
    }

    if ($('[data-section-type="corporate-gifting-file-upload"]').length > 0) {
        corporateFileUpload();
    }

    if ($('[data-section-type="quick-order-form"]').length > 0) {
        quickOrderForm();
    }


    //smooth scroll if internal link

    $(document).on('click', 'a', function (e) {
        if ($(this).attr('href').indexOf('#') == 0 && $(this).attr('href').length > 1 && $($(this).attr('href')).length > 0) {
            e.preventDefault();

            var scrolltop = $($(this).attr('href')).offset().top - $('#section-header').height();

            $('html, body').animate({ scrollTop: scrolltop }, 300);
            return false;
        }
    })

    $(document).on('change', '.QuantitySelector__CurrentQuantity[step]', function () {
        console.log('triggered');
        var qty = $(this).val();
        var step = $(this).attr('step');
        if (qty % step != 0 && $(this).val() && $(this).val() != '' && $(this).val() > 0) {
            var modulo = qty % step;
            var result = Math.ceil(qty / step);

            var newValue = result * step;

            $(this).val(newValue);

        }

    });

    // $('body').on('click', '#calculate-rates', function (e) {
    //     e.preventDefault();
    //     //$(this).hide().after(preloader_svg);
    //     $('#callback-message').remove();
    //     $('#zapiet-widget-container').show();

        //onCalculateRate();



        // $('.Cart--expanded .CartItem__Info>.CartItem__Actions .QuantitySelector__CurrentQuantity').each(function () {
        //     if (items_count != '') items_count += ';';
        //     items_count += $(this).val();
        // });

        // if (global_zip_rates[zip_code]) {
        //     setTimeout(function () {
        //         set_dates_to_calendar(zip_code, items_count, 'div#outlet');
        //         $('#calculate-rates').show();
        //         $('#calculate-rates').next().remove();
        //     }, 2000);
        // }
        // else {
        //     $.ajax({
        //         type: 'GET',
        //         dataType: "json",
        //         crossDomain: true,
        //         url: api_url + "/get_rates.php?l=1782&zip=" + zip_code,
        //         success: function (responseData, textStatus, jqXHR) {
        //             // let rates_data = JSON.parse(responseData);
        //             if (responseData['type']) {
        //                 global_zip_rates[zip_code] = responseData['data'];
        //                 set_dates_to_calendar(zip_code, items_count, 'div#outlet');
        //             }
        //             else {
        //                 $('#zip-picker').after('<p id="callback-message">' + responseData['data'] + '</p>');
        //             }

        //             $('#calculate-rates').show();
        //             $('#calculate-rates').next().remove();
        //         },
        //         error: function (responseData, textStatus, errorThrown) {
        //             $('#zip-picker').after('<p id="callback-message">Wrong request, try again later!</p>');
        //             $('#calculate-rates').show();
        //             $('#calculate-rates').next().remove();
        //         }
        //     });
        // }
    });

    $('body').on('change', '.itemMultishipAddress .options-holder input[type=radio]', function () {
        let parent = $(this).parents('.itemMultishipAddress');
        let selected_value = parent.find('.options-holder input[type=radio]:checked').attr('data-name');
        let items = selected_value.split(';');
        let zip_code = items[7].replace(/\s/g, "");
        parent.attr('data-zip-code', zip_code);
    });

document.addEventListener("change", function(e) {
    if (e.target.classList.contains('QuantitySelector__CurrentQuantity')) {
        console.log("Removing?");
        $("div#outlet .picker__day:not(.picker__day--disabled)").removeAttr('data-rate-cost');
        //$(".Cart__Checkout").prop('disabled', 'disabled');
    }
});

document.addEventListener("click", function(e) {
    if (e.target.classList.contains('CartItem__Remove')) {
        console.log("Removing?");
        $("div#outlet .picker__day:not(.picker__day--disabled)").removeAttr('data-rate-cost');
       //$(".Cart__Checkout").prop('disabled', 'disabled');
    }
});

$(document).ready(function () {

    $('.options-holder input[type=radio]:checked').each(function () {
        let items = $(this).attr('data-name').split(';');
        let zip_code = items[7].replace(/\s/g, "");
        $(this).parents('.itemMultishipAddress').attr('data-zip-code', zip_code);

        if (!global_zip_rates[zip_code]) {
            $.ajax({
                type: 'GET',
                dataType: "json",
                crossDomain: true,
                url: api_url + "/get_rates.php?l=1826&zip=" + zip_code,
                success: function (responseData, textStatus, jqXHR) {
                    if (responseData['type']) {
                        global_zip_rates[zip_code] = responseData['data'];
                        console.log(global_zip_rates);
                    }
                },
                error: function (responseData, textStatus, errorThrown) { }
            });
        }
    });

    $('#rates-popup').click(function (e) {
        if (e.target == this) {
            $('#rates-popup').fadeOut();
        }
    });

    $('#rates-popup-btn').click(function () {
        $('#rates-popup').fadeIn();
    });

    $('.rates-popup__close').click(function () {
        $('#rates-popup').fadeOut();
    });

    $('main .shopify-section:last-child').each(function () {
        var content = $(this).html().trim();
        if (content == '') {
            $(this).remove();
        }
    })

  $('[data-section-type="shop-the-look"] .swap-wrapper button').click(function(){
    if(!$(this).hasClass('.selected')) {
      $(this).siblings().removeClass('selected');
      $(this).addClass('selected');

      $(this).parents('.ProductItem').find('a').attr('href', $(this).data('url'));
      $(this).parents('.ShopTheLook__ProductList').find('.ShopTheLook__ViewButton').attr('href', $(this).data('url'));

      $(this).parents('.ProductItem').find('.ProductItem__Price').html($(this).data('price'));
    }
  })
});